import React from 'react';
import PropTypes from 'prop-types';
import { WBMErrorMessage } from 'wbm-error-message';

class WBMLoader extends React.PureComponent {
    render() {
        if (this.props.hasError) {
            return (
                <WBMErrorMessage />
            );
        }

        return (
            <div className="wbm-loader">
                {
                    this.props.customLoader ?
                        <img
                            src={this.props.customLoader}
                        />
                        :
                        this.props.truckLoader ?
                            <img
                                src="https://images.wbmason.com/GIF/WB_Truck_LoadingImage.gif"
                                alt="truck loader"
                            />
                            :
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                }
            </div>
        );
    }
}

WBMLoader.propTypes = {
    customLoader: PropTypes.string,
    truckLoader: PropTypes.bool,
    hasError: PropTypes.bool
};

export default WBMLoader;  